import { styled as c, Button as d } from "@mui/material";
import { jsx as g } from "react/jsx-runtime";
const m = ({
  image: r,
  imageHover: n = null,
  imageClicked: o = null,
  onClick: t = null,
  disabled: a = !1,
  children: u
}) => {
  const e = c(d)(() => ({
    minWidth: 0,
    width: "100%",
    height: "100%",
    backgroundImage: r,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    ...a ? {
      backgroundBlendMode: "multiply",
      backgroundColor: "#00000080"
    } : {},
    ...n ? {
      "&:hover": {
        backgroundImage: n,
        backgroundSize: "contain"
      }
    } : {},
    ...o ? {
      "&:active": {
        backgroundImage: o,
        backgroundSize: "contain"
      }
    } : {}
  }));
  return /* @__PURE__ */ g(e, {
    disabled: a,
    onClick: () => t ? t() : "",
    children: u
  });
};
export {
  m as default
};
//# sourceMappingURL=ImageButton.js.map
